export default "__VITE_ASSET__DcJfiK4I__"